import cuid from "cuid";
import { v4 as uuidv4 } from "uuid";
const { name, version } = require("../../package.json");

type GenerateHeadersOptions = (auth: any, ownerId?: string, workspaceId?: string, headers?: object) => object;

export const generateHeaders: GenerateHeadersOptions = (auth, ownerId, workspaceId, headers = {}) => {
    const sub = auth?.tokenData?.sub || "XXXXXX";
    return {
        "Content-Type": "application/json",
        "X-App-Version": version,
        "X-App-Name": name,
        "X-Item-Id": ownerId,
        "X-User-Id": sub,
        "X-Correlation-Id": uuidv4(),
        "X-Request-ID": cuid(),
        ...(workspaceId ? { "X-Workspace-ID": workspaceId } : { "X-Workspace-ID": ownerId }),
        ...headers
    };
};
